/**
 * Proyecto: MOGOTAX-SERVER
 * Autor: Megatrack GPS SAS
 * Fecha de creación: 8 de mayo de 2025
 * Licencia: Propiedad Privada
 *
 * Este código es propiedad exclusiva de Megatrack GPS SAS & Mogotax SAS y no puede ser distribuido, copiado, modificado, publicado, sublicenciado ni comercializado sin el consentimiento expreso y por escrito de ambas empresa.
 *
 * Copyright (c) 2025 Megatrack GPS SAS. Todos los derechos reservados.
 */
// src/App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ConfigProvider } from "antd";
import esES from "antd/lib/locale/es_ES";
import moment from "moment";
import "moment/locale/es";

import LoginForm from "./Components/modules/Login/LoginForm";
import ForgotPasswordPage from "./Components/modules/Login/ForgotPasswordPage";
import ResetPasswordPage from "./Components/modules/Login/ResetPasswordPage";
import ChangePasswordPage from "./Components/modules/Login/ChangePasswordPage";
import Modules from "./Components/modules/Modules";
import TrasladoMapView from "./Components/modules/Dashboard/TrasladoMapView";
import ProtectedRoute from "./ProtectedRoute";
import CookieConsent from "./Components/CookieConsent";
import InstallPrompt from "./Components/InstallPrompt";

import { UserProvider } from "./UserContext";
import { SocketProvider } from "./SocketContext";
import { TrasladosProvider } from "./TrasladosContext";
import { SettingsProvider } from "./SettingsContext";
import { CookieConsentProvider } from "./CookieConsentContext";
import { TermsProvider } from "./Contexts/TermsContext";
import { OtpProvider } from "./Contexts/OtpContext";
import TermsModal from "./Components/TermsModal";
import PrivacyPolicyModal from "./Components/PrivacyPolicyModal";

// Servicio de actualización forzada
import forceUpdateService from "./utils/forceUpdate";

moment.locale("es");

function App() {
  // Inicializar servicio de actualización automática
  useEffect(() => {
    forceUpdateService.start();

    return () => {
      forceUpdateService.stop();
    };
  }, []);
  return (
    <ConfigProvider locale={esES}>
      <UserProvider>
        <SocketProvider>
          <TrasladosProvider>
            <SettingsProvider>
              <OtpProvider>
                <CookieConsentProvider>
                  <TermsProvider>
                  <Router>
                    <Routes>
                      {/* Redirige raíz a login */}
                      <Route path="/" element={<Navigate replace to="/login" />} />

                      {/* Pantalla de login */}
                      <Route path="/login" element={<LoginForm />} />

                       {/* Nueva ruta para recuperación de contraseña */}
                       <Route path="/forgot-password" element={<ForgotPasswordPage />} />

                      {/* Nueva ruta para restablecer contraseña */}
                      <Route path="/reset-password" element={<ResetPasswordPage />} />

                      {/* Ruta para cambio de contraseña obligatorio */}
                      <Route path="/change-password" element={<ChangePasswordPage />} />

                      {/* Cualquier ruta bajo /modules/* es protegida */}
                      <Route
                        path="/modules/*"
                        element={
                          <ProtectedRoute>
                            <Modules />
                          </ProtectedRoute>
                        }
                      />

                      {/* Vista de mapa de traslados también protegida */}
                      <Route
                        path="/modules/dashboard/traslado/:id"
                        element={
                          <ProtectedRoute>
                            <TrasladoMapView />
                          </ProtectedRoute>
                        }
                      />

                      {/* Fallback: si no coincide, redirige a login */}
                      <Route path="*" element={<Navigate to="/login" />} />
                    </Routes>

                    {/* Consentimiento de cookies */}
                    <CookieConsent />

                    {/* Prompt de instalación PWA */}
                    <InstallPrompt />

                    {/* Términos y Condiciones */}
                    <TermsModal />

                    {/* Política de Privacidad */}
                    <PrivacyPolicyModal />
                  </Router>
                  </TermsProvider>
                </CookieConsentProvider>
              </OtpProvider>
            </SettingsProvider>
          </TrasladosProvider>
        </SocketProvider>
      </UserProvider>
    </ConfigProvider>
  );
}

export default App;